function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.468 12.37C12.758 11.226 11.195 10 8 10s-4.757 1.225-5.468 2.37A6.987 6.987 0 008 15a6.987 6.987 0 005.468-2.63z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 9a3 3 0 100-6 3 3 0 000 6z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 1a7 7 0 100 14A7 7 0 008 1zM0 8a8 8 0 1116 0A8 8 0 010 8z",
  clipRule: "evenodd"
});

function SvgAboutMe(props) {
  return React.createElement("svg", _extends({
    className: "about-me_svg__bi about-me_svg__bi-people-circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktcGVvcGxlLWNpcmNsZSIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0xMy40NjggMTIuMzdDMTIuNzU4IDExLjIyNiAxMS4xOTUgMTAgOCAxMHMtNC43NTcgMS4yMjUtNS40NjggMi4zN0E2Ljk4NyA2Ljk4NyAwIDAwOCAxNWE2Ljk4NyA2Ljk4NyAwIDAwNS40NjgtMi42M3oiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDlhMyAzIDAgMTAwLTYgMyAzIDAgMDAwIDZ6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDFhNyA3IDAgMTAwIDE0QTcgNyAwIDAwOCAxek0wIDhhOCA4IDAgMTExNiAwQTggOCAwIDAxMCA4eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPg==";
export { SvgAboutMe as ReactComponent };